import { Layout, Menu } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import { Suspense } from 'react';
import { Outlet, ScrollRestoration, useNavigate } from 'react-router-dom';
import { Loading } from '../components/common/Loading';
import ErrorBoundary from '../components/common/ErrorBoundary';

export const AdminLayout = () => {
  const navigate = useNavigate();

  return (
    <Layout
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <ScrollRestoration />
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'white',
          boxShadow: '0 1px 5px 0 rgba(0, 0, 0, .1)',
        }}
      >
        {/* antd v6 で Menu の children 指定が非推奨になったため items 形式で指定する */}
        <Menu
          mode="horizontal"
          items={[
            {
              key: 'organizations',
              label: '施設一覧',
              onClick: () => navigate('/admin/'),
            },
            {
              key: 'patients',
              label: '患者一覧',
              onClick: () => navigate('/admin/patients'),
            },
            {
              key: 'organizations-rate',
              label: '施設割合',
              onClick: () => navigate('/admin/organizations/rate'),
            },
          ]}
        />
        <Menu
          mode="horizontal"
          items={[
            {
              key: 'signout',
              label: 'ログアウト',
              onClick: () => navigate('/signout'),
            },
          ]}
        />
      </Header>
      <Layout>
        <Content
          style={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start', // 追加: 縦方向の配置を上端に揃える
            padding: 16,
            background: '#F5FAFF',
          }}
        >
          <ErrorBoundary>
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </Content>
      </Layout>
    </Layout>
  );
};
